import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import NotFound from "../NotFound/NotFound";
import Box from "../Box/Box";
import {
  get_slider,
  get_image,
  parse_book_URL,
  get_course_URL,
  get_book_URL,
} from "../../helper";
import api from "../../axios";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import { FaTiktok, FaWhatsapp } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { AiOutlineClose, AiFillYoutube, AiFillFacebook } from "react-icons/ai";
import { IoMdAlbums } from "react-icons/io";
import { BsInstagram, BsLinkedin } from "react-icons/bs";
import logo from "../../assets/logo.png"; // Add this import

const phoneNumber = "+201027097226";
const whatsappURL = `https://wa.me/${phoneNumber}`;
const Service = () => {
  const [service, setService] = useState({});
  const [covers, setCovers] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [cards, setCards] = useState([]);
  const [setting, setSetting] = useState({});
  const [courses, setCourses] = useState([]);
  const [books, setBooks] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupImages, setPopupImages] = useState([]);
  const [sliderIndex, setSliderIndex] = useState(0);
  const [isSliderPopupOpen, setIsSliderPopupOpen] = useState(false);
  const { id } = useParams();
  const serviceID = parse_book_URL(id);

  useEffect(() => {
    const fetchBook = async () => {
      try {
        const response = await api.get(
          `https://api.sae-grad.com/api/services/${serviceID}`,
          {
            params: { populate: "*" },
          }
        );
        setService(response.data.data);
        setCovers(response?.data?.data?.attributes?.sliders?.data || []);
      } catch (error) {
        if (error.response) {
          console.log("Error data:", error.response.data);
          console.log("Error status:", error.response.status);
          console.log("Error headers:", error.response.headers);
          if (error.response.status === 403) {
            console.log(
              "Access forbidden: Check your API key and permissions."
            );
          }
        } else if (error.request) {
          console.log("Error request:", error.request);
        } else {
          console.log("Error message:", error.message);
        }
        setNotFound(true);
      }
    };
    api
      .get("/setting", {
        params: {
          populate: "*",
        },
      })
      .then((response) => {
        setSetting(response.data.data.attributes);
      });
    api.get("/courses").then((response) => {
      setCourses(response.data.data);
    });
    api
      .get("courses/", {
        params: {
          pagination: {
            pageSize: 50,
          },
          populate: [
            "instructors.image",
            "gallery.image",
            "gallery.images",
            "home_image",
            "sliders",
            "video",
            "pdf_file",
          ],
          locale: "en",
        },
      })
      .then((response) => {
        setCovers(response?.data?.data?.attributes?.slider?.data || []);
        console.log(response?.data?.data?.attributes);
      })
      .catch((error) => {
        setNotFound(true);
        console.log(error);
      });
    api.get("/play-books").then((response) => {
      setBooks(response.data.data);
    });
    fetchBook();
  }, [serviceID]);

  if (notFound) return <NotFound />;
  if (!service?.id)
    return (
      <div className="loader-container">
        <img className="loader-image" src={logo} alt="Loading..." />
      </div>
    );
  const handleImageClick = (images, index) => {
    setPopupImages(images?.data || []);
    setSliderIndex(index);
    setIsSliderPopupOpen(true);
  };
  return (
    <>
      <section className="interior">
        <div className="intro-image">
          <Swiper
            navigation={true}
            modules={[Navigation, Autoplay, Pagination]}
            className="mySwiper"
            autoplay={{ delay: 2000 }}
            pagination={{ clickable: true }}
            effect="coverflow"
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
          >
            {covers.map((cover, index) => (
              <SwiperSlide key={index}>
                <div className="intro-image-container">
                  <img
                    className="animated-coverflow"
                    loading="auto"
                    src={get_slider(cover)}
                    alt={`cover ${index + 1}`}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="section-container">
          <div className="text">
            <h1>{service?.attributes?.title}</h1>
            <p>
              <strong>{service?.attributes?.author}</strong>
            </p>
          </div>
          <div className="instructors" id="urban-mobile">
            {service.length > 0 && (
              <h1 className="featured">Service Description</h1>
            )}
            <div
              className="instructor-info"
              style={{
                backgroundColor: "#1C1C1C",
                width: "100%",
                marginBottom: "15px",
                borderRadius: "25px",
                padding: "2rem",
                direction: "rtl",
                textAlign: "justify",
              }}
            >
              {service?.attributes?.description && (
                <p style={{ fontSize: "18px" }}>
                  {service.attributes.description}
                </p>
              )}
            </div>
          </div>
          {cards.length > 0 && (
            <div className="Gallery">
              <div className="text">
                <h2>Gallery</h2>
              </div>
              <div className="gallery">
                <div className="gallery-container">
                  {cards.map((card, index) => (
                    <div
                      className="gallery-card"
                      key={index}
                      onClick={() => handleImageClick(card.images, index)}
                    >
                      <div className="image">
                        <img src={get_image(card.image)} alt="gallery" />
                        <div>
                          <IoMdAlbums className="album" />
                        </div>
                      </div>
                      <div className="card-text">
                        <div className="heading">
                          <h1>{card.name}</h1>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {isSliderPopupOpen && (
                  <div className="slider-popup">
                    <div className="slider-popup-content">
                      <div
                        className="slider-close-icon"
                        onClick={() => setIsSliderPopupOpen(false)}
                      >
                        <AiOutlineClose />
                      </div>
                      <Swiper
                        navigation={true}
                        modules={[Navigation, Pagination]}
                        initialSlide={sliderIndex}
                        className="slider-popup-swiper"
                        pagination={{ clickable: true }}
                      >
                        {popupImages.map((image, index) => (
                          <SwiperSlide key={index}>
                            <div className="slider-popup-image">
                              <img src={get_slider(image)} alt="popup" />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <Box
            textContent={{
              discount: service?.attributes?.discount || "",
            }}
            buttonHref={service?.attributes?.form_url || "#"}
            whatsapp_link={setting?.whatsapp_link}
            confirmationMessage={service?.attributes?.confirmation_message}
          />
          <div className="footer">
            <div className="social">
              <h3>Contact Us</h3>
              <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
                <FaWhatsapp /> {phoneNumber}
              </a>
              <a href={setting?.facebook_link} target="_blank" rel="noreferrer">
                <AiFillFacebook className="icon" /> Facebook
              </a>
              <a
                href={setting?.instagram_link}
                target="_blank"
                rel="noreferrer"
              >
                <BsInstagram className="icon" /> Instagram
              </a>
              <a
                href="mailto:info@sae-grad.com"
                target="_blank"
                rel="noreferrer"
              >
                <CiMail className="icon" /> Mail
              </a>
              <a href={setting?.tiktok_link} target="_blank" rel="noreferrer">
                <FaTiktok className="icon" /> TikTok
              </a>
              <a href={setting?.linkedin_link} target="_blank" rel="noreferrer">
                <BsLinkedin className="icon" /> LinkedIn
              </a>
              <a href={setting?.youtube_link} target="_blank" rel="noreferrer">
                <AiFillYoutube className="icon" /> Youtube
              </a>
            </div>
            <div className="course">
              <h3>Other Programs</h3>
              {[...courses]
                .sort((a, b) => a.attributes.rank - b.attributes.rank) // تصاعدي
                .map((course) => (
                  <Link
                    key={course.id}
                    to={`/courses/${get_course_URL(course)}`}
                  >
                    {course?.attributes?.title}
                  </Link>
                ))}
            </div>

            <div className="course">
              {books && books.length > 0 && (
                <>
                  <h3>Other Playbooks</h3>
                  <div className="playbooks-list">
                    {books.map((book) => (
                      <Link
                        key={book?.id ?? book?.attributes?.id ?? Math.random()}
                        to={"/play-books/" + get_book_URL(book)}
                      >
                        {book?.attributes?.title}
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Service;
